import React from 'react';
import {
  BridgecrestInformationWrapper,
  BridgecrestPartnershipWrapper,
  BridgecrestPartnershipLabel,
  BridgecrestContactInfoWrapper,
  BridgecrestContactInfo,
  BridgecrestContactInfoQuestion,
  BridgecrestContactInfoAnswer,
  BridgecrestHyperLink,
  BridgecrestUrl,
  BridgecrestLogo,
} from './BridgecrestInformation.styles';
import BCLogo from '../../../assets/BridgecrestLogo.png';

const BridgecrestInformation = () => {
  return (
    <BridgecrestInformationWrapper>
      <BridgecrestPartnershipWrapper>
        <BridgecrestPartnershipLabel>
          In partnership with
        </BridgecrestPartnershipLabel>
        <BridgecrestLogo src={BCLogo} alt="random" />
      </BridgecrestPartnershipWrapper>

      <BridgecrestContactInfoWrapper>
        <BridgecrestContactInfo>
          <BridgecrestContactInfoQuestion>
            Need help or have questions about your account/loan?
          </BridgecrestContactInfoQuestion>
          <BridgecrestContactInfoAnswer>
            Contact Bridgecrest at{' '}
            <BridgecrestHyperLink href="tel:8009678526" type="external">
              800-967-8526
            </BridgecrestHyperLink>{' '}
            or go to
            <BridgecrestUrl href="https://www.bridgecrest.com" type="external">
              https://www.bridgecrest.com
            </BridgecrestUrl>
            for more details.
          </BridgecrestContactInfoAnswer>
        </BridgecrestContactInfo>
      </BridgecrestContactInfoWrapper>
    </BridgecrestInformationWrapper>
  );
};

export default BridgecrestInformation;
